/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const GeofencePolygon = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <g fill="none">
      <path d="M18.037 33.898l76.792-20.246M94.829 14.712l17.017 102.914M111.846 118.656L16.975 98.472M15.604 97.916l2.741-63.103" />
    </g>
    <path d="M96.59 101.35h26.252v25.15H96.59z" />
    <path d="M102.031 105.926h16.318v15.138h-16.318zM81.703 2.136h26.252v25.152H81.703z" />
    <path d="M87.143 6.713h16.318v15.136H87.143z" />
    <g>
      <path d="M5.219 85.342h26.252v25.15H5.219z" />
      <path d="M10.658 89.919h16.318v15.135H10.658z" />
    </g>
    <g>
      <path d="M4.911 22.238h26.251V47.39H4.911z" />
      <path d="M10.35 26.815h16.318v15.136H10.35z" />
    </g>
  </svg>
);
export default extendIcon(GeofencePolygon);
